import { useField, useFormikContext } from 'formik'
import get from 'lodash.get'
import {
  Input as UIInput,
  INumberInputProps,
} from '@nextretreat/ui-components/dist/Input'
import { IVenueFormValues } from 'FormPage/FormPage'

interface IInputFormikProps extends Omit<INumberInputProps, 'name'> {
  name: string
}

export const NumberInputFormik = ({
  invalid,
  name,
  ...passingProps
}: IInputFormikProps) => {
  const { errors, touched } = useFormikContext<IVenueFormValues>()
  const [field] = useField({ name, type: 'number' })

  return (
    <UIInput.Number
      {...field}
      {...passingProps}
      invalid={invalid || !!(get(errors, name) && get(touched, name))}
    />
  )
}
